"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyName = exports.displayName = exports.date = void 0;
var dateValidator_1 = require("./dateValidator");
Object.defineProperty(exports, "date", { enumerable: true, get: function () { return dateValidator_1.dateValidator; } });
// dummy validators for display purposes
var displayNameValidator = function (value) { return true; };
exports.displayName = displayNameValidator;
var propertyNameValidator = function (value) { return true; };
exports.propertyName = propertyNameValidator;
//# sourceMappingURL=index.js.map